'use client';
// apps/admin/src/app/error.tsx — React error boundary
// + отправка в систему трекинга ошибок
import { useEffect } from 'react';
import { reportClientError } from '@tb/ui';

export default function AdminError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError({
      service: 'admin',
      severity: 'error',
      name: error.name || 'RenderError',
      message: error.message || error.toString(),
      stack: error.stack,
      context: { source: 'error_boundary', digest: error.digest },
    });
  }, [error]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="text-center">
        <div className="mb-4 text-5xl">⚠️</div>
        <h2 className="mb-2 text-xl font-bold text-foreground">Что-то пошло не так</h2>
        <p className="mb-4 text-sm text-muted-foreground">
          Ошибка отправлена разработчикам. Попробуйте обновить страницу.
        </p>
        <button
          onClick={reset}
          className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition hover:bg-primary/90"
        >
          Повторить
        </button>
      </div>
    </div>
  );
}
